import { useTranslation } from "react-i18next";
import bannerImg from "../../../assets/banner.jpg";
import "./style.css";
import { useSelector } from "react-redux";
import { motion } from "framer-motion";

const AboutUs = ({ data }) => {
	const { t } = useTranslation();
	const lang = useSelector((state) => state.lang.lang);

	return (
		<div
			className="about-us"
			style={{
				backgroundImage: `url(${bannerImg})`,
			}}>
			<div>
				<motion.p
					initial={{ opacity: 0 }}
					animate={{ opacity: 1 }}
					transition={{ delay: 0.25, duration: 1 }}
					className="title">
					{t("about-us")}
				</motion.p>
				<motion.p
					initial={{ opacity: 0 }}
					animate={{ opacity: 1 }}
					transition={{ delay: 0.25, duration: 1 }}
					className="description"
					dangerouslySetInnerHTML={{
						__html: !!data?.length ? data[0][`description_${lang}`] : "",
					}}></motion.p>
			</div>
		</div>
	);
};
export default AboutUs;
